import { createSlice } from "@reduxjs/toolkit";
import { statusData, typeData } from "./EasyBinTransferAction";

const initialState = {
  Summary: {
    loc: "",
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
    statusVal: typeData[0].id,
    typeVal: statusData[0].id,
  },
  Src: {
    DocTypCode: "",
    DocTypName: "",
    DocNo: 0,
    Date: new Date(),
    LocCode: "",
    LocName: "",
    Type: "",
    Status: "Enter",
    BinCodeFrom: "",
    BinNameFrom: "",
    ItemCode: "",
    ItemName: "",
    CardId: 0,
    Qty: 0,
    UnitCode: "",
    UnitName: "",
    BaseQty: 0,
    BinCodeTo: "",
    BinNameTo: "",
    PackQty:0,
  },
  Desc: { 
  },
  
  
};

const SliceEasyBinTransfer = createSlice({
  name: "SliceEasyBinTransfer",
  initialState: { value: initialState },

  reducers: {
    EasyBinTransfer_Init: (state) => {
      state.value = initialState;
    },
    EasyBinTransfer_Src: (state) => {
      state.value.Src = initialState.Src;
    },
    EasyBinTransfer_Unit:(state, action)  => {
      state.value.Src.UnitCode = action.payload.UnitCode;
      state.value.Src.PackQty = action.payload.PackQty;
    },
    EasyBinTransfer_BaseQty:(state, action)  => {
      state.value.Src.BaseQty = action.payload.BaseQty; 
    },
    Summary_Set: (state, action) => {
      state.value.Summary = action.payload;
    },
    Src_Set: (state, action) => {
      state.value.Src = action.payload;
    },
    
   
  },
});

export const {
  EasyBinTransfer_Init,
  EasyBinTransfer_Src,
  Summary_Set,
  EasyBinTransfer_Unit,
  EasyBinTransfer_BaseQty,
  Src_Set,  
} = SliceEasyBinTransfer.actions;
export default SliceEasyBinTransfer.reducer;
